const INIT_FILTER_VALUE = {
    export_isOpen: false
};

const state = () => {
    return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
    filterIsOpen({ commit }) {
        commit("setExportOpen");
    },
    resetAllProvData({ commit }) {

    }
};

// mutations
const mutations = {
    setExportOpen(state, item) {
        state.export_isOpen = item;
    },
    clearStore(state) {
        state = { ...INIT_FILTER_VALUE };
    },
};

// getters
const getters = {
    export_isOpen: (state) => state.export_isOpen
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
